import type { NotificationTone } from '@/services/notifications/types';

/** Os `colorScheme` que o `Tag` do design system aceita e o portal já usa. */
export type TagColorScheme =
  | 'gray'
  | 'blue'
  | 'green'
  | 'success'
  | 'error'
  | 'warning'
  | 'yellow';

type ToneClasses = {
  /** Fundo e cor do ícone no painel do sino. */
  iconWrapper: string;
  /** `colorScheme` do `Tag` do design system, usado na tabela. */
  tagColorScheme: TagColorScheme;
};

/**
 * Tom → classes. O tom vem da API junto da notificação, então um tipo novo
 * ganha cor sem tocar em componente.
 */
export const NOTIFICATION_TONE_CLASSES: Record<NotificationTone, ToneClasses> =
  {
    success: {
      iconWrapper: 'bg-alba-green-100 text-alba-green-700',
      tagColorScheme: 'success',
    },
    error: {
      iconWrapper: 'bg-alba-red-100 text-alba-red-700',
      tagColorScheme: 'error',
    },
    warning: {
      iconWrapper: 'bg-alba-yellow-100 text-alba-yellow-700',
      tagColorScheme: 'warning',
    },
    info: {
      iconWrapper: 'bg-alba-blue-100 text-alba-blue-700',
      tagColorScheme: 'blue',
    },
  };
